export const setTitle = (currentTitle) => {
  document.title = currentTitle;
};
